import { Outlet, useLocation } from 'react-router';
import ErrorPage from '@/components/pages/ErrorPage';
import { isSubdomain } from '@/utils/domain';

const SubdomainGuard = () => {
  const location = useLocation();
  const subdomain = isSubdomain();

  if (subdomain) {
    if (location.pathname.startsWith('/product/')) {
      return <Outlet />;
    }

    return <ErrorPage />;
  }

  return <Outlet />;
};

export default SubdomainGuard;
